<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <img v-lazy="'/img/logo.png'" height="60px" />
      </nav>
      <div class="copyright">
        <a href="mailto://info@nodgames.com">
              Contact : info@nodgames.com
        </a>
        <br/>
        &copy; {{ year }}, NOD Games, Inc
        <br>
        <a href="/doc/privacy.html" style="margin: 5px;" target="_blank">Privacy Policy</a><a href="/doc/terms.html" style="margin: 5px;" target="_blank">Terms of use</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
